<template>
<div style="width:100%;padding-top: 60px">
  <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
    <div style="text-align:center">
      <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">办理</van-button>
      <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
    </div>
    <div class="doTask" v-if="isshow">
      <div>
        <van-field name="radio" label="审批意见">
          <template #input>
            <van-radio-group v-model="auditForm.status" direction="horizontal">
              <van-radio name="同意">同意</van-radio>
              <van-radio name="不同意">不同意</van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
      <div>
        <van-cell-group>
          <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea" placeholder="请输入审批说明" />
        </van-cell-group>
      </div>
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交</van-button>
      </div>
    </div>
  </div>

  <van-collapse v-model="activeNames">
    <van-field v-model="inputForm.settlementDate" label="结算日期" label-width="120px" readonly input-align="left" :border="false" />
    <van-field :value="settlementItemLabel" label="结算事项" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field :value="businessTypeLabel" label="业务类型" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field v-model="inputForm.businessPartyYiName" label="会签/合同乙方" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field v-model="inputForm.businessName" label="会签/合同名称" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field v-model="inputForm.businessCode" label="会签/合同编号" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field :value="formatAmount(inputForm.payableAmount)" label="本次应付金额（元）" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field :value="formatAmount(inputForm.settlementAmount)" label="本次结算金额（元）" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field v-model="inputForm.createByName" label="制单人" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <van-field v-model="inputForm.createDate" label="制单日期" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <div style="padding-left: 16px; font-size: 14px; margin-top: 10px; margin-bottom: 10px;" v-show="inputForm.attachList && inputForm.attachList.length > 0">
      <p style="color: #AAA">附件</p>
      <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.attachList" :key="index"
         @click="$viewAttach(file)">{{ file.name }}</p>
    </div>
    <van-field v-model="inputForm.remarks" label="备注" label-width="120px" readonly type="textarea" autosize rows="1" :border="false" />
    <div style="margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
      <p style="display: block; color: #4caedc" @click="viewBusinessDetail()">查看结算业务明细</p>
    </div>
    <div style="margin-bottom: 10px; margin-top: 10px; padding-left: 16px">
      <p style="display: block; color: #4caedc" @click="viewSummaryDetail()">查看结算金额汇总</p>
    </div>

  </van-collapse>
  <process-record :procInsId="procInsId"></process-record>
</div>
</template>

<script>
import processRecord from "@/components/processRecord/processRecord.vue";
import TaskService from "@/api/flowable/TaskService";
import ProcessService from "@/api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";

export default {
  name: "ApmsRegContractSettlement",
  data(){
    return {
      activeNames: ["1","2","3"],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type:'',
      settlementItemLabel: '',
      businessTypeLabel: '',
      inputForm:{
        settlementDate: '',
        settlementItem: '',
        businessType: '',
        businessId: '',
        businessCode: '',
        businessName: '',
        businessPartyYiName: '',
        payableAmount: '0.00',
        settlementAmount: '0.00',
        remarks: '',
        createByName: '',
        createDate: '',
        businessList: [],
        summaryList: [],
        attachList: [],
        isDoTask: false,
        isLastTask: false,
      },
    }
  },
  computed: {
    businessPartyLabel() {
      if (this.inputForm.businessType === '1') {
        return '合同乙方'
      } else if (this.inputForm.businessType === '2') {
        return '会签乙方'
      }
      return '会签/合同乙方'
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
    if(!window.matchMedia("(orientation:portrait)").matches){
      dd.device.screen.resetView({
        onSuccess : function(result) {},
        onFail : function(err) {}
      });
    }
  },
  methods: {
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/apms/reg/apmsRegContractSettlement/queryById').then(({ data }) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate ? data.createDate.slice(0, 10) : ''
        this.inputForm.settlementDate = data.settlementDate ? data.settlementDate.slice(0, 10) : ''
        this.inputForm.payableAmount = Number(data.payableAmount || 0).toFixed(2)
        this.inputForm.settlementAmount = Number(data.settlementAmount || 0).toFixed(2)
        if (!this.inputForm.businessList || this.inputForm.businessList.length === 0) {
          this.inputForm.businessList = []
        }
        if (!this.inputForm.summaryList || this.inputForm.summaryList.length === 0) {
          this.inputForm.summaryList = []
        }
        if (!this.inputForm.attachList || this.inputForm.attachList.length === 0) {
          this.inputForm.attachList = []
        }
        this.getDict([
          ['apms_settlement_item', 'settlementItem'],
          ['apms_team_business_type', 'businessType'],
        ])
      }).catch(e => {
        console.log(e)
      })
    },
    getDict(dicts) {
      new QueryInfoService().getDictMap().then(({data}) => {
        dicts.map(([dictType, formField]) => {
          if (this.inputForm[formField] !== null && this.inputForm[formField] !== undefined && this.inputForm[formField] !== '') {
            const dictList = data[dictType] || [];
            const dictItem = dictList.find(item => item.value == this.inputForm[formField]);
            const label = dictItem ? dictItem.label : '';
            this.$set(this.inputForm, `${formField}Label`, label);
            if (formField === 'settlementItem') {
              this.settlementItemLabel = label
            }
            if (formField === 'businessType') {
              this.businessTypeLabel = label
            }
          } else {
            this.$set(this.inputForm, `${formField}Label`, '');
            if (formField === 'settlementItem') {
              this.settlementItemLabel = ''
            }
            if (formField === 'businessType') {
              this.businessTypeLabel = ''
            }
          }
        })
      }).catch(e => {
        console.log(e)
      })
    },
    formatAmount(value) {
      const num = Number(value)
      if (isNaN(num)) return '0.00'
      return num.toFixed(2)
    },
    close() {
      if(this.type !== '') {
        this.$router.back()
      } else {
        dd.biz.navigation.close({
          onSuccess: function (result) {},
          onFail: function (err) {}
        })
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {},
          onFail: function () {}
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        _this.auditForm.type = _this.inputForm.isLastTask?'_flow_approval':'_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
          }
          _this.$flow.startFlow(form, '/apms/reg/apmsRegContractSettlement/startFlow');
          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({ data }) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
          }
          _this.$flow.startFlow(form, '/apms/reg/apmsRegContractSettlement/startFlow');
          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    viewBusinessDetail(){
      this.$router.push({
        path: '/ApmsRegContractSettlementBusinessDetail',
        query: {
          data: JSON.stringify(this.inputForm.businessList)
        }
      })
    },
    viewSummaryDetail(){
      this.$router.push({
        path: '/ApmsRegContractSettlementSummaryDetail',
        query: {
          data: JSON.stringify(this.inputForm.summaryList)
        }
      })
    },
  }
}
</script>

<style scoped>
</style>
